const Helper = () => {
    const buttonScrollTo = document.querySelectorAll('[target="_scrollto"]');
    const scrollToTop = document.querySelector('.gototop');

    buttonScrollTo.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            const componentName = event.target.getAttribute('href').substring(1);
            const component = document.querySelector(`[data-component="${componentName}"]`);
            const componentBoundingClient = component.getBoundingClientRect().top;
            const formTop = componentBoundingClient + window.scrollY - 100;

            window.scroll({
                top: formTop,
                behavior: 'smooth',
            });
        });
    });

    scrollToTop.addEventListener('click', () => {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    });

};

export default Helper;
